
export enum ApplicationCd {
	DOCK_AUTO = 'DockAuto',
	INSPECTION = 'Inspection',
	LNHL_OPS = 'LnhlOps',
	MIMS = 'Mims',
	PDOPS = 'PDOPS',
	XDOCK = 'XDOCK'}
